<template>
    <div :class="$style['box']">
      <span :class="$style['box-title']">
        Latest earnings
      </span>
      <span :class="$style['box-subtitle']">
        Last 3 months
      </span>
    </div>
    <div v-if="lastThreeMonths.length > 1" :class="$style['box-l']">
      <div v-for="profit in lastThreeMonths" :class="$style['profit-box']" v-bind:key="profit.id">
        <div :class="$style['profit-box-init']">
          <span :class="$style['profit-box-percent']">
            {{  (Math.trunc(profit.roe_month * 100) / 100).toFixed(2) }}%
          </span>

          <div style="display: flex;flex-direction: column;">
            <span :class="$style['profit-box-init-month']">
              {{ getMonthName(profit.date) }}
            </span>
            <span :class="$style['profit-box-init-value']">
              {{ formatToUSD(profit.difference) }}
            </span>
          </div>
        </div>
        <div :class="$style['profit-box-info']">
          <span :class="$style['profit-box-info-month']">
            {{  getMonthNumber(profit.date)  }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="lastThreeMonths.length < 1" style="font-size: 18px;font-weight: 800;text-align: center;margin-top: 25px;">
      No Data Found
    </div>
</template>

<script>
import { formatToUSD } from '@/helpers/currencyFormatter';


export default {
  name: 'LatestProfits',

  data() {
    return {
      lastThreeMonths: [],
    }
  },

  props: {
    profits: {
      type: Array,
      default: () => [],
    },
  },

  components: {
  },

  mounted() {
    this.getLastThreeMonths()
  },

  methods: {
    formatToUSD,
    getLastThreeMonths() {
      const _profits = [...this.profits];
      const sortedData = _profits.sort((a, b) => new Date(b.date) - new Date(a.date))

      this.lastThreeMonths = sortedData.slice(1, 4).reverse()
    },
    getMonthName(dateString) {
      const date = new Date(dateString)
      const monthName = date.toLocaleString('en-US', { month: 'long', year: 'numeric' })

      return monthName
    },
    getMonthNumber(dateString) {
      const date = new Date(dateString)
      const monthNumber = (date.getMonth() + 1).toString().padStart(2, '0')

      return monthNumber
    },
  }
}
</script>

<style lang="scss" module>

  .box-l {
    margin-top: 10px;
    display: grid;
    gap: 25px;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

    @include respond-to(null, 'sm') {
      gap: 10px !important;
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }

  }

  .box {
    display: flex;
    gap: 25px;
    align-items: center;

    @include respond-to(null, 'xs') {
      gap: 5px !important;
      flex-wrap: wrap;
    }

    &-title {
      color: #D9D9D9;
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px;

      @include respond-to(null, 'xs') {
        font-size: 22px !important;
      }
    }

    &-subtitle {
      color: #A6A6A6;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
  }

  .profit-box {
    border-radius: var(--Border_radius-16, 16px);
    background: var(--Surface, rgba(45, 45, 45, 0.35));
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    gap: 30px;
    padding: 15px 20px;
    justify-content: space-between;

    @include respond-to(null, 'xs') {
      padding: 10px 10px 0 10px!important;
    }

    &-percent {
      color: #7CF95C;
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      border-radius: 4px;
      border: 1px solid #7CF95C;
      padding: 7px 14px;

      @include respond-to(null, 'xs') {
        border: unset;
        padding: unset;
        min-width: 35%;
        font-size: 18px;
        margin-top: -10px;
      }
    }

    &-init {
      display: flex;
      align-items: center;
      gap: 20px;
      
      @include respond-to(null, 'xs') {
        gap: 10px !important;
        flex: 1;
      }

      &-value {
        color:  #D9D9D9;
        font-family: $font-secondary;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px;
        top: -7px;
        position: relative;

        @include respond-to(null, 'xs') {
          font-size: 14px !important;
        }
      }

      &-month {
        color: #D9D9D9;
        font-family: $font-secondary;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;

        @include respond-to(null, 'xs') {
          font-size: 20px;
        }
      }
    }

    &-info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;

      @include respond-to(null, 'xs') {
        display: none !important;
      }

      &-month {
        color: rgba(0, 0, 0, 0.25);
        font-size: 72px;
        font-style: normal;
        font-weight: 700;
        line-height: 58px;
      }
    }
  }

</style>
